export default function ({ store, redirect, app }) {
  if (store.state.app.updateAvailable) {
    app.$updateApp()
  }
}
